import { Injectable } from '@angular/core';
import { InventoryService } from '../inventory/inventory.service';
import { Inventory } from '../inventory/inventory';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { SliceQuery } from '../api/api.defs';
import { ServiceTimesRow } from './services.defs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ServicesService {

	all = new BehaviorSubject<Inventory[]>([])

	constructor(
		private _inventory: InventoryService,
		private _api: ApiService,
	) { }

	fetch() {
		return forkJoin(
				this._inventory.fetchServices([['$field', 'DISPLAYORDER']]),
				this._api.request<SliceQuery<ServiceTimesRow>>({'$/slice/report': {
					slice: environment.slices.serviceTimes,
				}}, 'services.serviceTimes')
			)
			.pipe(
				map(resp => {
					// mixes the service times into the inventory minute override
					const services = resp[0],
						times = resp[1].rows;

					times.forEach(time => {
						const s = services.find(s => s.id === time.SERVICERef);
						if (s) {
							s.customTimes.set(time.BARBERRef, time.MINUTES);
						}
					});
					return services;
				}),
				tap(rows => this.all.next(rows))
			)
	}
}
